import {
    AI_AGENT_MAX_IMAGE_BYTES,
    fileToDataUrl,
    isAiAgentVisionImage,
} from './fileToDataUrl';
import type {PendingChatAttachment} from '../../aiMessageGenerator/utils/types';

export type AttachmentImageError = 'unsupported' | 'tooLarge';

type AttachmentImageResult = {
    dataUrl?: string;
    error?: AttachmentImageError;
};

export async function resolveAttachmentImage(
    attachment: PendingChatAttachment | null | undefined,
): Promise<AttachmentImageResult> {
    const file = attachment?.file;
    if(!file) {
        return {};
    }
    if(!isAiAgentVisionImage(file)) {
        return {error: 'unsupported'};
    }
    if(file.size > AI_AGENT_MAX_IMAGE_BYTES) {
        return {error: 'tooLarge'};
    }
    try {
        return {dataUrl: await fileToDataUrl(file)};
    } catch {
        return {error: 'unsupported'};
    }
}
